import styled from 'styled-components'

export const ProcedureHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
`

export const CodeAndBadge = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const SecondaryProcedureRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  .MuiCheckbox-root {
    padding: 0;
    margin-right: 0.5rem;
    flex-shrink: 0;
  }
`
